"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FPCTPageFourConfirmation;
var _formik = require("formik");
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _reactBootstrap = require("react-bootstrap");
var _FPCTPageThree = _interopRequireDefault(require("./FPCTPageThree"));
var _CircleWithCheck = _interopRequireDefault(require("./svg/CircleWithCheck"));
var _utils = require("../../middleware/utils");
var _FinancialPlanningCheckupWizardTool = require("./FinancialPlanningCheckupWizardTool.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function FPCTPageFourConfirmation(_ref) {
  var {
    submitToPdf
  } = _ref;
  var {
    values: {
      firstName
    },
    values
  } = (0, _formik.useFormikContext)();
  var [item, setItem] = (0, _react.useState)('');
  var [loading, setLoading] = (0, _react.useState)(false);
  var handleItemClick = eventKey => () => {
    setItem(item === eventKey ? null : eventKey);
  };
  var handleDownloadClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* () {
      setLoading(true); // Set loading to true before the API call
      try {
        yield submitToPdf(values); // Call the API
        (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'Download Analysis');
      } catch (error) {
        console.error('Error downloading analysis:', error);
      } finally {
        setLoading(false); // Set loading to false after the API call completes
      }
    });
    return function handleDownloadClick() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'mm-spacing'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'mm-spacing'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-start"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_CircleWithCheck.default, null)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h4", {
    className: 'margin-bottom-0'
  }, "Thanks, ", firstName, ". We\u2019ve received your contact information. A MassMutual affiliated financial advisor will reach out to you soon."), /*#__PURE__*/_react.default.createElement("p", null, "In the meantime, here are some tips on ", '', /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.massmutual.com/financial-wellness/balancing-financial-and-professional-responsibilities#76B4F139-5C04-4034-9216-9CDC7FBDE892",
    target: '_blank',
    rel: "noreferrer"
  }, "preparing for the first meeting."))))), /*#__PURE__*/_react.default.createElement("div", {
    className: 'mm-spacing'
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "primary",
    type: "button",
    onClick: handleDownloadClick,
    disabled: loading
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'icon-download-white'
  }), /*#__PURE__*/_react.default.createElement("span", null, loading ? 'Downloading...' : 'Download Analysis'))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Group, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Toggle, {
    eventKey: '0',
    onClick: handleItemClick('0'),
    open: item === '0'
  }, "View analysis"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Collapse, {
    eventKey: '0'
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_FPCTPageThree.default, {
    onlyShowAnalysis: true
  })))))));
}